import React from "react";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import FormModal from "../FormModal";

const GrantAccessModal = ({ show, setShow, fullName, modalUserId, modalId340b }) => {
  return (
    <React.Fragment>
      <FormModal
        show={show}
        title="Grant User-Entity Access"
        modalId={`grant_access_${modalId340b}_${modalUserId}`}
        buttonText="Grant Access"
        buttonType="success"
        secondaryButtonText="Reject"
        fields={
          <React.Fragment>
            <Form.Label>
              Are you sure you want to grant {fullName} access to {modalId340b}? Please confirm they
              have provided the necessary verification. If not, please click "Reject".
            </Form.Label>
          </React.Fragment>
        }
        action={`/entities/${modalId340b}/users/${modalUserId}/approve`}
        secondaryButtonAction={`/entities/${modalId340b}/users/${modalUserId}/reject`}
        method="PATCH"
        dismiss={() => {
          setShow(false);
        }}
      />
    </React.Fragment>
  );
};

export default GrantAccessModal;
